import {
  CUSTOM_NUMBER_CELL_FORMAT,
  CUSTOM_PERCENT_4_CELL_FORMAT,
  CUSTOM_PERCENT_6_CELL_FORMAT,
} from '../xlsxExport.constants';

export const MetadataStyle = {
  alignment: { horizontal: 'left' },
};

export const SectionHeaderStyle = {
  height: 30,
  alignment: {
    vertical: 'middle',
  },
};

export const HeaderRowStyle = {
  ...SectionHeaderStyle,
  font: { bold: true },
  alignment: {
    horizontal: 'center',
    vertical: 'bottom',
    wrapText: true,
  },
  border: {
    bottom: { style: 'thin' },
  },
};

export const TextRowStyle = {
  font: { bold: true },
};

export const DataRowStyle = {
  numFmt: CUSTOM_NUMBER_CELL_FORMAT,
};

export const DataBorderTopLineStyle = {
  ...DataRowStyle,
  border: {
    top: { style: 'thin' },
  },
};

export const DataBorderDoubleBottomLineStyle = {
  ...DataRowStyle,
  border: {
    bottom: { style: 'double' },
  },
};

export const DataBorderTopLineDoubleBottomLineStyle = {
  ...DataRowStyle,
  border: {
    top: { style: 'thin' },
    bottom: { style: 'double' },
  },
};

export const ChildDataDescriptionStyle = {
  ...DataRowStyle,
  alignment: { indent: 1 },
};

export const DataRowBoldStyle = {
  ...DataRowStyle,
  font: { bold: true },
};

export const ParentDataRowStyle = {
  ...DataRowBoldStyle,
  height: 25,
  alignment: {
    vertical: 'middle',
  },
};

export const ParentSummary = {
  ...DataRowBoldStyle,
  border: {
    top: { style: 'thin' },
  },
};

export const ParentSummaryDouble = {
  ...DataRowBoldStyle,
  border: {
    top: { style: 'double' },
  },
};

export const PaddingColumnStyle = {
  width: 12,
};

export const DataColumnStyle = {
  width: 20,
  numFmt: CUSTOM_NUMBER_CELL_FORMAT,
};

export const TotalColumnStyle = {
  ...DataColumnStyle,
  font: { bold: true },
};

export const PercentageColumnStyle = {
  ...DataColumnStyle,
  font: { bold: true },
  numFmt: CUSTOM_PERCENT_4_CELL_FORMAT,
};

export const CustomColumnStyle = {
  width: 25,
  numFmt: CUSTOM_PERCENT_6_CELL_FORMAT,
  alignment: {
    horizontal: 'left',
  },
};

